import React from "react";
import { Link } from "react-router-dom";
import { useHiddenCategories } from "../../api/hiddenCategories";
import "./VaidikVidhya.css";
const categories = [
  {
    title: "Rudrakshas",
    slug: "rudrakshas",
  },
  {
    title: "Gemstones",
    slug: "gemstones",
  },
  {
    title: "Crystals & Healing Stones",
    slug: "crystals",
  },
  {
    title: "Shankh & Sea Shells",
    slug: "shankh-sea-shells",
  },
  {
    title: "Vastu Products",
    slug: "vastu-products",
  },
  {
    title: "Tulsi Products",
    slug: "tulsi",
  },
  {
    title: "Pooja Essentials",
    slug: "pooja",
  },
  {
    title: "Shop By Astrology",
    slug: "shop-by-astrology",
  },
];

const CategoryButtons = () => {
  const { isCategoryHidden } = useHiddenCategories();
  return (
    <section className="category-section">
      <div className="vv-container">
        <div className="section-title">
          <span>Shop by Category</span>

          <h2>Find the Right Spiritual Products</h2>
          <div className="about-heading-line">
            <img
              src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
              alt="Heading decoration"
            />
          </div>
          <p>
            Select your preferred category and explore our authentic collection
            of spiritual products.
          </p>
        </div>

        <div className="category-grids">
          {categories
            .filter((item) => !isCategoryHidden(item.slug, item.title))
            .map((item, index) => (
            <Link
              key={index}
              to={`/shop/${item.slug}`}
              className={`category-box ${item.slug}`}
            >
              <div className="category-content">
                <h3>{item.title}</h3>
                <span className="category-arrow">Explore →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryButtons;
